import { defineComponent as r, computed as o, useCssModule as a, openBlock as l, createBlock as m, resolveDynamicComponent as n, normalizeClass as d, withCtx as i, renderSlot as u } from "vue";
import p from "../../utils/mapClasses.mjs";
import { responsiveModifyClass as f } from "../../utils/buildClass.mjs";
import c from "../../utils/propValidator.mjs";
import g from "./styles/CdrGrid.module.scss.mjs";
import C from "../../../_virtual/_plugin-vue_export-helper.mjs";
const y = r({
  name: "CdrGrid",
  props: {
    /**
    * Defines gutter size. Also accepts responsive values with `@breakpoint`: "none@md"
    * @demoSelectMultiple false
    * @values none, small, medium, large
    */
    gutter: {
      type: String,
      validator: (e) => c(e, ["none", "small", "medium", "large"]),
      default: "medium@xs medium@sm large@md large@lg"
    },
    /** Sets the HTML tag for the grid element */
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    const s = "cdr-grid", t = o(() => e.gutter ? f(s, "gutter-", e.gutter) : null);
    return {
      style: a(),
      baseClass: s,
      gutterClass: t,
      mapClasses: p
    };
  }
});
function $(e, s, t, _, M, S) {
  return l(), m(n(e.tag), {
    class: d(e.mapClasses(e.style, e.baseClass, e.gutterClass))
  }, {
    default: i(() => [u(e.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
const v = {
  $style: g
}, z = /* @__PURE__ */ C(y, [["render", $], ["__cssModules", v]]);
export {
  z as default
};
